import React, { useState } from "react";
import { Divider, IconButton, List, ListItemButton, Typography } from "@mui/material";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import { Link } from "react-router-dom";
import Collapse from '@mui/material/Collapse';
import styled from "styled-components";
import moment from "moment";
import { DRAWER_WIDTH, VbListItemIcon, VbListItemText, VbToolBarLogo } from "./components";
import { isMobileDevice } from "../../../commons/utils";
import { Calendar, LayoutDashboard, LogOut, X } from "lucide-react";
import { FaComputer, FaRegPaste } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { RiMenuAddFill } from "react-icons/ri";
import { IoPeopleSharp } from "react-icons/io5";
import { PiKanbanFill, /*PiPiggyBank*/ } from "react-icons/pi";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const rotas = [
    { label: 'Dashboard', to: '/', icon: <LayoutDashboard /> },
    {
        label: 'Pessoas', icon: <IoPeopleSharp />,
        children: [
            { label: 'Cliente', to: '/cliente' },
            { label: 'Lead', to: '/lead' },
            { label: 'Prospect', to: '/prospect' },
            { label: 'Usuário', to: '/usuario' },
            { label: 'Usuário Empresa', to: '/usuarioempresa' }
        ]
    },
    {
        label: 'Planejamento', icon: <FaRegPaste />,
        children: [
            { label: 'Categoria', to: '/categoria' },
            { label: 'Método', to: '/metodo' },
            { label: 'Exercício', to: '/exercicio' },
            { label: 'Repetição/Tempo', to: '/repeticaotempo' },
            { label: 'Plano Aula', to: '/planoaula' },
            { label: 'Plano Aula Modalidade', to: '/planoaulamodalidade' }
        ]
    },
    /*{
        label: 'Financeiro', icon: <PiPiggyBank />,
        children: [
            { label: 'Conta', to: '/conta' },
            { label: 'Categoria', to: '/categoria-financeiro' },
            { label: 'Forma de Pagamento', to: '/forma-pagamento' },
            { label: 'Centro de Resultado', to: '/centro-resultado' },
            { label: 'Fornecedor', to: '/fornecedor' }
        ]
    },*/
    {
        label: 'WhatsApp', icon: <FaWhatsapp />,
        children: [
            { label: 'Template Mensagem', to: '/templatemensagem' },
            { label: 'Instância', to: '/instancia' }
        ]
    },
    {
        label: 'Outros', icon: <RiMenuAddFill />,
        children: [
            { label: 'Aula', to: '/aula' },
            { label: 'Local', to: '/local' },
            { label: 'Modalidade', to: '/modalidade' },
            { label: 'Motivo', to: '/motivo' },
            { label: 'Privilégio', to: '/privilegio' },
            { label: 'Tipo Prospecção', to: '/tipoprospeccao' },
            { label: 'Turma', to: '/turma' },
        ]
    },
    {
        label: 'Consultas', icon: <FaComputer />,
        children: [
            { label: 'Logs', to: '/logs' },
            { label: 'Feedbacks', to: '/feedbacks' },
            { label: 'Doações', to: '/doacoes' }
        ]
    },
    {
        label: 'Kanbans', icon: <PiKanbanFill />,
        children: [
            { label: 'Controle Lead', to: '/controlelead' },
            { label: 'Controle Prospecção', to: '/controleprospeccao' }
        ]
    },
    { label: 'Agenda', to: '/agenda', icon: <Calendar /> },
    {
        label: 'Relatórios', icon: <PiKanbanFill />,
        children: [
            { label: 'Faltas', to: '/report_faltas' }
        ]
    },

];


const VbDivider = () => {
    return (
        <Divider variant='middle' style={{ backgroundColor: '#e0e0e0' }} />
    )
}

const ButtonRetrair = (props: any) => {
    return (
        isMobileDevice() ?
            <IconButton color="inherit" edge="end" sx={{ ml: 8 }} onClick={() => props?.onClick && props.onClick()}>
                <X />
            </IconButton> : null
    )
}

const VbFooterCopyright = styled.footer`
    bottom: 0;
    width: ${DRAWER_WIDTH};
    background-color: 'var(--side-bar-color)';
    color: #fff;
    text-align: center;
    margin: 20px 0 20px 0;
`

interface OpenState {
    [key: string]: boolean;
}

export const SideBar = (props: any) => {
    const auth = useAuth();

    const [openSubItem, setOpenSubItem] = useState<OpenState>({ Cadastros: true });

    const handleClick = (label: any, to: any) => {
        props?.clickItemMenu && props.clickItemMenu(to);
        setOpenSubItem(prev => ({
            [label]: !prev[label]
        }));
    };

    return (
        <>
            <VbToolBarLogo> <ButtonRetrair onClick={props.clickExpanded} /> </VbToolBarLogo>
            <List>
                {rotas.map((rota: any, index: number) => (
                    ((!rota.privilegio) || rota.privilegio(auth)) &&
                    <React.Fragment key={index}>
                        <ListItemButton component={rota.to && Link} to={rota.to} onClick={() => handleClick(rota.label, rota.to)} >
                            <VbListItemIcon icon={rota.icon} />
                            <VbListItemText label={rota.label} />
                            {rota.children ? openSubItem[rota.label] ? <ArrowDropDownIcon width={'18px'} /> : <ArrowRightIcon width={'18px'} /> : <></>}
                        </ListItemButton>

                        {
                            rota.children?.map((child: any, i: number) => (
                                <Collapse key={i} in={openSubItem[rota.label]} timeout={300} unmountOnExit >
                                    {
                                        ((!child.privilegio) || child.privilegio(auth)) &&
                                        <ListItemButton component={Link} to={child?.to} onClick={() => { props?.clickItemMenu && props.clickItemMenu('') }} dense>
                                            <VbListItemText label={child.label} sx={{ ml: 4, p: '1px 0' }} />
                                        </ListItemButton>
                                    }
                                </Collapse>
                            ))
                        }
                        {(index !== rotas.length - 1) && <VbDivider />}
                    </React.Fragment>
                ))}

                <VbDivider />
                <ListItemButton onClick={() => auth.logout()}>
                    <VbListItemIcon icon={<LogOut />} />
                    <VbListItemText label='Sair' />
                </ListItemButton>
            </List>


            <Divider style={{ backgroundColor: '#f1f1f1ba' }} />
            <VbFooterCopyright>
                <div style={{ fontSize: '14px' }}>
                    {'Usuário: ' + auth.usunome} <br />
                </div>
                <Typography sx={{ fontSize: 11, mt: '10px' }}>
                    {'© Copyright VbFit ' + moment().year() + '.'} <br />
                    {'Todos os direitos reservados.'}
                </Typography>
            </VbFooterCopyright>
        </>
    )
}